const drawerWidth = 240;

export default drawerWidth;